// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2PAr8UMEVZeh2Z2hsSjjtH","icon":"_6Dazv2cC1kda-ESBxYEk-","rightEl":"_9-kzl2amQ8wdOSNtqmhTD","highlighted":"yKJ3xC5uULdbfAZUQjO8f","text":"_1qLErtEcgarZUEy98kHx12"};